import { maskPhone } from "../functionsGlobal";
import { getToken } from "../services/auth";
import { Currency } from "../shared/Functions";
import { useDate } from "./useDate";



export const usePrintDelivery = () => {
    const {formatDate} = useDate()


    const printIframe = async ({payment, clientInfo}) => {
        const infoClient = clientInfo[0]
        const horaEnvio = infoClient.hora_envio ?? ""
        const products = infoClient.delivery_produto
        const today = new Date();
        const resultFormatdate = formatDate(today, 'dd/mm/aaaa');

        const withdraw = `
            <div class="alert">
                <p><b>RETIRADA</b></p>
            </div>
        `
        let baseHtml = ''
        products.forEach(item => baseHtml+=`<div class="info-wrapper">
                                                <div class="right-content">
                                                    <p>
                                                        ${item.nome}
                                                    </p>
                                                </div>
                                                <div>
                                                    <p>
                                                        ${item.qtd}x
                                                    </p>
                                                </div>
                                                <div>
                                                    <p>
                                                        ${Currency(item.preco)}
                                                    </p>
                                                </div>
                                                <div>
                                                    <p>
                                                        ${Currency(item.total)}
                                                    </p>
                                                </div>
                                            </div>
                                            `);  

        let now = new Date()

        const iframe = document.querySelector("iframe").contentWindow;
        iframe.document.querySelector('body').innerHTML = `
        <!DOCTYPE>
            <html>
                <head>
                    <style type="text/css">
                        @page{
                            margin:0cm;
                        }

                        body{
                            font-family: Tahoma, Geneva, sans-serif;
                        }

                        p{
                            margin:0;
                        }

                        .container{
                            max-width:400px;
                            border: solid 1px #000;
                            display:flex;
                            flex-direction:column;
                            gap:6px;
                            padding:4px;
                        }

                        .wrapper, .alert{
                            display:flex;
                            justify-content:center;
                        }

                        .title{
                            margin-top:20px;
                            border: solid 2px #000000;
                            padding-left:50px;
                            padding-right:50px;
                            font-size:16px;
                            display:flex;
                            flex-direction:column;
                            gap:4px;
                            align-items:center;
                        }
                        .store-name{
                            font-size:10px;
                        }

                        .store-address{
                            font-size:10px;
                            text-transform: uppercase;
                            text-align:center;
                        }

                        .data-info-wrapper, .total-wrapper{
                            display:flex;
                            flex-direction:column;
                            gap:4px;
                        }

                        .info-wrapper, .items-descriptions{
                            display: flex;
                            justify-content: space-between;
                            align-items:center;
                        }

                        .info, .total{
                            display:flex;
                            font-size:10px;
                            gap:4px;
                        }

                        .inssuance{
                            display:flex;
                            gap:6px;
                        }

                        .products-wrapper{
                            display:flex;
                            font-size:10px;
                            flex-direction:column;
                            gap:4px;
                        }

                        .right-content, .right-content-description{
                            width:50%;
                        }
                        
                        .items-descriptions{
                            font-size:10px;
                        }

                        .right-content-description{
                            text-align:center;
                        }

                        .total{
                            justify-content:flex-end;
                        }

                        .alert{
                            font-size:14px;
                        }
                        .wrapper-payment{
                            display:flex;
                            width:100%;
                            flex-direction:column;
        
                            .payment{
                                display:flex;
                                font-size:10px;
                                gap:4px;
                            }

                            .row{
                                display:flex;
                                width:100%;
                

                                font-size:10px
                            }
                            
                        }

                    </style>    
                </head>
                <body>            
                    <div class="container">
                        <div class="wrapper">
                            <div class="title">
                                <p>Delivery</p>
                                <p>${infoClient.id}</p>
                            </div>
                        </div>
                        <div class="wrapper">
                            <div class="store-name">
                                <p><b>${getToken('NOMEEMPRESA')}</b></p>
                            </div>
                        </div>
                        <div class="wrapper">
                            <div class="store-address">
                                <p>${infoClient.logradouro},${infoClient.numero},${infoClient.bairro},${infoClient.cidade},${infoClient.cep}</p>
                            </div>
                        </div>
                        ${infoClient.retirar_loja === "S" ? withdraw : " "}
                        <div class="data-info-wrapper">
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Emissao:</p>
                                    <div class="inssuance">
                                        <p><b>${resultFormatdate}</b></p>
                                        <p><b>${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}</b></p>
                                    </div>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Data:</p>
                                    <p><b>${infoClient.data_abertura}</b></p>
                                </div>
                                <div class="info">
                                    <p>Hora:</p>
                                    <p><b>${infoClient.hora_abertura}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Entregador:</p>
                                    <p><b>${infoClient.nome_entregador ?? ""}</b></p>
                                </div>
                                <div class="info">
                                    <p>H.envio:</p>
                                    <p><b>${horaEnvio}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Usuário:</p>
                                    <p><b>${getToken('LOGIN')}</b></p>
                                </div>
                            </div>
                        </div>
                        <div class="data-info-wrapper">
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Cliente:</p>
                                    <p><b>${infoClient.nome_cliente}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Telefone:</p>
                                    <p><b>${maskPhone(infoClient.cel1)}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>CEP:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " : infoClient.cep_entrega}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>logradouro:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " : `${infoClient.logradouro_entrega}, ${infoClient.numero_entrega}`}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Bairro:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " :infoClient.bairro_entrega}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Cidade:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " :infoClient.cidade_entrega}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Referencia:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " :infoClient.referencia_entrega}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Complemento:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " :infoClient.complemento_entrega}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>OBS:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " :infoClient.obs ?? ""}</b></p>
                                </div>
                            </div>
                        </div>
                        <div class="items-descriptions">
                            <div class="right-content-description">
                                <p>
                                    <b>Produto</b>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>qtd</b>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>unid.</b>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>total</b>
                                </p>
                            </div>
                        </div>
                        <div class="products-wrapper"> 
                            ${baseHtml}                                                
                        </div>
                        <div class="total-wrapper">
                            <div class="total">
                                <p><b>SubTotal:</b></p>
                                <p>${Currency(infoClient.subtotal)}</p>
                            </div>
                            <div class="total">
                                <p><b>Total:</b></p>
                                <p>${Currency(infoClient.total)}</p>
                            </div>
                        </div>

                        <div class="wrapper-payment">
                            <p class="payment"><b>Forma de Pagamento:</b></p>
                            ${payment.map(item =>  
                                `
                                    <div class="row">
                                        <p>${item.tipo_nome}: ${Currency(item.valor)} </p>
                                    </div>
                                `
                            ).join(' ')
                            }
                            ${infoClient.troco !== 0 ?  `
                                    <div class="row">
                                        <p>Troco: ${Currency(infoClient.troco)} </p>
                                    </div>
                                ` 
                                : ''
                            }

                        </div>
                        <div class="alert">
                            <p><b>NÃO TEM VALOR FISCAL</b></p>
                        </div>
                    </div>
                <body/>    
            </html>
        `;
        iframe.focus();
        iframe.print();
        return false;
    }; 

    
    const  printIframeFinish = (info) => {
        const infoClient = info
        const horaEnvio = infoClient.hora_envio ?? ""
        const adress = infoClient.endereco 
        const products = info.produtos
        const payments = infoClient.forma_pagamento
        const today = new Date();
        const resultFormatdate = this.formatDate(today, 'dd/mm/aaaa');
        const withdraw = `
            <div class="alert">
                <p><b>RETIRADA</b></p>
            </div>
        `
        let basePayment =''
        payments.forEach(item => basePayment+=`<div class="payment">
                                                <p>
                                                    ${item.nome}
                                                </p>
                                                <p>
                                                    ${Currency(item.valor)}
                                                </p>
                                            </div>
                                            `);  
    
    
        let baseHtml = ''
        products.forEach(item => baseHtml+=`<div class="info-wrapper">
                                                <div class="right-content">
                                                    <p>
                                                        ${item.nome_produto}
                                                    </p>
                                                </div>
                                                <div>
                                                    <p>
                                                        ${item.qtd}x
                                                    </p>
                                                </div>
                                                <div>
                                                    <p>
                                                        ${Currency(item.preco)}
                                                    </p>
                                                </div>
                                                <div>
                                                    <p>
                                                        ${Currency(item.total)}
                                                    </p>
                                                </div>
                                            </div>
                                            `);  
    
        let now = new Date()
    
        const iframe4 = document.querySelector("iframe").contentWindow;
        iframe4.document.querySelector('body').innerHTML = `
        <!DOCTYPE>
            <html>
                <head>
                    <style type="text/css">
                        @page{
                            margin:0cm;
                        }
    
                        body{
                            font-family: Tahoma, Geneva, sans-serif;
                        }
    
                        p{
                            margin:0;
                        }
    
                        .container{
                            max-width:400px;
                            border: solid 1px #000;
                            display:flex;
                            flex-direction:column;
                            gap:6px;
                            padding:4px;
                        }
    
                        .wrapper, .alert{
                            display:flex;
                            justify-content:center;
                        }
    
                        .title{
                            margin-top:20px;
                            border: solid 2px #000000;
                            padding-left:50px;
                            padding-right:50px;
                            font-size:16px;
                            display:flex;
                            flex-direction:column;
                            gap:4px;
                            align-items:center;
                        }
    
                        .store-name{
                            font-size:10px;
                        }
    
                        .store-address{
                            font-size:10px;
                            text-transform: uppercase;
                            text-align:center;
                        }
    
                        .data-info-wrapper, .total-wrapper{
                            display:flex;
                            flex-direction:column;
                            gap:4px;
                        }
    
                        .info-wrapper, .items-descriptions{
                            display: flex;
                            justify-content: space-between;
                            align-items:center;
                        }
    
                        .info, .total{
                            display:flex;
                            font-size:10px;
                            gap:4px;
                        }
    
                        .inssuance{
                            display:flex;
                            gap:6px;
                        }
    
                        .products-wrapper{
                            display:flex;
                            font-size:10px;
                            flex-direction:column;
                            gap:4px;
                        }
    
                        .right-content, .right-content-description{
                            width:50%;
                        }
                       
                        .items-descriptions{
                            font-size:10px;
                        }
    
                        .right-content-description{
                            text-align:center;
                        }
    
                        .total{
                            justify-content:flex-end;
                        }
    
                        .alert{
                            font-size:14px;
                        }
    
                        .payment-wrapper{
                            display:flex;
                            font-size:14px;
                            flex-direction:column;
                            align-items:center;
                        }
    
                        .payment{
                            display:flex;
                            font-size:10px;
                            justify-content: space-between;
    
                        }
    
                    </style>    
                </head>
                <body>            
                    <div class="container">
                        <div class="wrapper">
                            <div class="title">
                                <p>Venda</p>
                                <p>${infoClient.numero}</p>
                            </div>
                        </div>
                        <div class="wrapper">
                            <div class="store-name">
                                <p><b>${getToken('NOMEEMPRESA')}</b></p>
                            </div>
                        </div>
                        <div class="wrapper">
                            <div class="store-address">
                                <p>${infoClient.endereco_estab}</p>
                            </div>
                        </div>
                        ${infoClient.retirar_loja === "S" ? withdraw : " "}
                        <div class="data-info-wrapper">
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Emissao:</p>
                                    <div class="inssuance">
                                        <p><b>${resultFormatdate}</b></p>
                                        <p><b>${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}</b></p>
                                    </div>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Data:</p>
                                    <p><b>${infoClient.data}</b></p>
                                </div>
                                <div class="info">
                                    <p>Hora:</p>
                                    <p><b>${infoClient.hora}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Entregador:</p>
                                    <p><b>${infoClient.entregador ?? ""}</b></p>
                                </div>
                                <div class="info">
                                    <p>H.envio:</p>
                                    <p><b>${horaEnvio}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Usuário:</p>
                                    <p><b>${getToken('LOGIN')}</b></p>
                                </div>
                            </div>
                        </div>
                        <div class="data-info-wrapper">
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Cliente:</p>
                                    <p><b>${infoClient.cliente}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Telefone:</p>
                                    <p><b>${this.PutMaskPhone(infoClient.cel1)}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>CEP:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " : adress.cep}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>logradouro:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " : `${adress.logradouro}, ${adress.numero}`}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Bairro:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " :adress.bairro}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Cidade:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " :adress.cidade}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Referencia:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " :adress.referencia}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>Complemento:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " :adress.complemento}</b></p>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="info">
                                    <p>OBS:</p>
                                    <p><b>${infoClient.retirar_loja === "S" ? " " :infoClient.obs}</b></p>
                                </div>
                            </div>
                        </div>
                        <div class="items-descriptions">
                            <div class="right-content-description">
                                <p>
                                    <b>Produto</b>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>qtd</b>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>unid.</b>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>total</b>
                                </p>
                            </div>
                        </div>
                        <div class="products-wrapper"> 
                            ${baseHtml}                                                
                        </div>
                        <div class="total-wrapper">
                            <div class="total">
                                <p><b>SubTotal:</b></p>
                                <p>${Currency(infoClient.total)}</p>
                            </div>
                            <div class="total">
                                <p><b>Total:</b></p>
                                <p>${Currency(infoClient.total)}</p>
                            </div>
                        </div>
                        <div class="total-wrapper">
                            <div class="payment-wrapper">
                                <p><b>Forma de pagamento</b></p>
                            </div>
                            ${basePayment}
                        </div>
                        <div class="alert">
                            <p><b>NÃO TEM VALOR FISCAL</b></p>
                        </div>
                    </div>
                <body/>    
            </html>
        `;
        iframe4.focus();
        iframe4.print();
        return false;
    }; 

    const printKitchen = (mode,reimpressao,impressao)=>{
        let idDeliveryKitchen = "" 
        let obsP = [];
        
        if(reimpressao[0]?.retorno === 'N') return;
    
        if(mode){
            obsP = reimpressao[0]?.impressoes ?? []
            idDeliveryKitchen = reimpressao[0]?.impressoes[0]?.id_movimento
        }else{
            obsP = impressao[0]?.impressoes ?? []
            idDeliveryKitchen = impressao[0]?.impressoes[0]?.id_movimento
        }
    
    
        let baseHtml2 = '';
        obsP.forEach(item => baseHtml2+=`
            <div class="products-wrapper">
                <div class="info-wrapper">
                    <div>
                        <p>
                            ${item.qtd}x
                        </p>
                    </div>
                    <div class="right-content-description">
                        <p>
                            ${item.nome_produto}
                        </p>
                  
                            ${
                                item.acom.length > 0 ? (
                                    item.acom.map(item => `<p class="complement-items"><b>${item.qtd}x ${item.nome}</b></p>` ).join(' ')
                                )
                                : ''
                            }
                       
                    </div>
                </div>
                <div class="obs-wrapper">
                    <div>
                        <p><b>OBS:</b></p>
                    </div>
                    <div class="right-content-description">
                        <p> ${item.obs_produto}</p>
                    </div>
                </div>
            </div>
        `);  


        const html = `
        <!DOCTYPE>
        <html>
            <head>
                <style type="text/css">
                    @page{
                        margin:0cm;
                    }
    
                    body{
                        font-family: Tahoma, Geneva, sans-serif;
                    }
    
                    p{
                        margin:0;
                    }
                    
                    .container{
                        max-width:400px;
                        border: solid 1px #000;
                        display:flex;
                        flex-direction:column;
                        gap:6px;
                        padding:4px;
                    }
    
                    .wrapper{
                        display:flex;
                        justify-content:center;
                    }
    
                    .title{
                        margin-top:20px;
                        border: solid 2px #000000;
                        padding-left:50px;
                        padding-right:50px;
                        font-size:16px;
                        display:flex;
                        flex-direction:column;
                        gap:4px;
                        align-items:center;
                    }
    
                    .items-header{
                        display: flex;
                        justify-content: space-between;
                        align-items:center;
                        font-size:10px;
                    }
    
                    .right-content-description{
                        width:85%;
                        text-align:center;
    
                        .complement-items{
                            width:100%;
                            font-size:8px !important;
                            color:gray;
                        }
                    }
    
                    .products-wrapper{
                        display:flex;
                        font-size:10px;
                        flex-direction:column;
                        gap:4px;
                    }
    
                    .info-wrapper{
                        display: flex;
                        justify-content: space-between;
                        align-items:center;
                    }
                    .obs-wrapper{
                        display: flex;
                        justify-content: space-between;
                    }
                    
                </style>    
            </head>
            <body>
                <div class="container">
                    <div class="wrapper">
                        <div class="title">
                            <p>Delivery</p>
                            <p>${idDeliveryKitchen}</p>
                        </div>
                    </div>
                    <div class="items-header">
                        <div>
                            <p>
                                <b>qtd.</b>
                            </p>
                        </div>
                        <div class="right-content-description">
                            <p>
                                <b>Produto</b>
                            </p>
                        </div>
                    </div>
                    <div class="products-wrapper"> 
                        ${baseHtml2}                                                
                    </div>
                </div>                    
            </body>            
        `
        return html;
    }

    return{
        printIframe, printIframeFinish, printKitchen
    }
}
